<template>
  <div class="sidebar-box p-2">
    <m-h6 v-t="`filter.search.title`"></m-h6>
    <form @submit.prevent="submitSearch()">
      <input v-model="search" class="form-control" :placeholder="$t('filter.search.place_holder')">
      <!-- دکمه سرچ -->
      <button type="submit" class="btn btn-primary mt-2">
        جستجو
      </button>
    </form>
  </div>
</template>

<script>
import mH6 from '../../Tags/H6'
import $ from 'jquery'
export default {
  name: "FilterSearch1",
  components: {mH6},
  data() {
    return {
      search: ''
    }
  },
  methods: {
    submitSearch() {
      // ارسال جستجو
      this.$emit('search', this.search);

      // بستن مودال با استفاده از jQuery زمانی که دکمه جستجو زده می‌شود
      $('#mobile-filters').modal('hide');
    }
  }
}
</script>

<style scoped>
.sidebar-box {
  border-radius: 10px;
  background: white;
  box-shadow: 0px 5px 25px rgba(218, 211, 211, 0.3);
  margin-bottom: 30px;
  border: 1px solid #F5F4F4;
}

button {
  width: 100%;
  font-size: 14px;
  padding: 10px;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
}
</style>
